import { useState } from 'react';
import logo from '../../assets/logo.png';
import {
  getPendingLogin,
  verifyPendingOtp,
  persistUserSession,
  consumeLoginReturnPath,
} from '../../services/auth';
import { useLanguage } from '../../context/LanguageContext';

const OtpPage = () => {
  const [code, setCode] = useState('');
  const [status, setStatus] = useState(null);
  const [statusType, setStatusType] = useState('error');
  const [submitting, setSubmitting] = useState(false);
  const pendingLogin = getPendingLogin();
  const pendingPhone = pendingLogin?.phone || '';
  const { t } = useLanguage();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);
    setStatusType('error');

    const sanitized = code.replace(/\s+/g, '');
    if (sanitized.length !== 6) {
      setStatus(t('otp.missing_code'));
      return;
    }

    setSubmitting(true);
    const result = await verifyPendingOtp(sanitized);
    if (!result.success) {
      setStatus(result.message || t('otp.verify_failed'));
      setSubmitting(false);
      return;
    }

    try {
      persistUserSession({
        user: result.user,
        token: result.token,
        role: result.role,
      });
      setStatusType('success');
      setStatus(t('otp.success'));
      const target = consumeLoginReturnPath() || '/';
      window.location.assign(target);
    } catch (authError) {
      setStatus(
        authError.message || t('otp.login_failed')
      );
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
  };

  if (!pendingLogin) {
    return (
      <div className="login">
        <div className="login__content">
          <img src={logo} alt="Wassini logo" className="login__logo" />
          <p className="login__tagline">{t('otp.tagline')}</p>
          <h1 className="login__title">{t('otp.no_request_title')}</h1>
          <p className="login__empty">
            {t('otp.no_request_message')}
          </p>
          <a href="/login" className="button button--primary login__submit">
            {t('otp.back_to_login')}
          </a>
        </div>
      </div>
    );
  }

  const maskedPhone =
    pendingPhone.length > 4
      ? `${pendingPhone.slice(0, -2).replace(/.(?=..)/g, '*')}${pendingPhone.slice(-2)}`
      : pendingPhone;

  const displayPhone = maskedPhone || t('otp.display_phone_fallback');

  return (
    <div className="login">
      <div className="login__content">
        <img src={logo} alt="Wassini logo" className="login__logo" />
        <p className="login__tagline">{t('otp.tagline')}</p>
        <h1 className="login__title">{t('otp.title')}</h1>
        <p className="login__hint">
          {t('otp.hint_prefix')} <span>{displayPhone}</span>. {t('otp.hint_suffix')}
        </p>
        <form className="login__form" onSubmit={handleSubmit}>
          <label>
            <span>{t('otp.code_label')}</span>
            <input
              type="text"
              inputMode="numeric"
              pattern="\d*"
              maxLength={6}
              name="otp"
              placeholder={t('otp.code_placeholder')}
              value={code}
              onChange={(event) => setCode(event.target.value.replace(/[^0-9]/g, ''))}
            />
          </label>
          {status && (
            <p
              className={`login__status${
                statusType === 'success' ? ' login__status--success' : ''
              }`}
            >
              {status}
            </p>
          )}
          <button
            type="submit"
            className="button button--primary login__submit"
            disabled={submitting}
          >
            {submitting ? t('otp.verifying') : t('otp.submit')}
          </button>
        </form>
        <p className="login__signup">
          {t('otp.wrong_number')}{' '}
          <a href="/login" className="login__signup-link">
            {t('otp.start_over')}
          </a>
        </p>
        <p className="login__powered">
          {t('otp.powered')} <span>Softwarezz</span>
        </p>
      </div>
    </div>
  );
};

export default OtpPage;
